<div class="page-header">
  <div>
    <h1>{{ t('SwissQrCodeLink') }}</h1>
    <p>{{ t('HubSwissQrIntro') }}</p>
  </div>
</div>

@if (errors['_global']) {
  <p class="message error">{{ errors['_global'] }}</p>
}

<form class="card qr-card form-grid" (ngSubmit)="generate()">
  @for (field of fields; track field) {
    <label>
      {{ label(field) }}
      @if (field === 'creditor-country') {
        <select [name]="field" [(ngModel)]="values[field]">
          <option value="CH">Schweiz</option>
        </select>
      }
      @if (field !== 'creditor-country') {
        <input [name]="field" [(ngModel)]="values[field]">
      }
      @if (errors[field]) {
        <span class="field-error">{{ errors[field] }}</span>
      }
    </label>
  }
  <button class="primary-button" type="submit">{{ loading ? t('HubGenerating') : t('SwissQrFormSubmitButton') }}</button>
</form>

@if (dataUri) {
  <div class="card qr-result">
    <a [href]="dataUri" download="swissqrcode.svg">
      <img [src]="dataUri" alt="QR Code">
      <span>{{ t('QrCodeDownloadLink') }}</span>
    </a>
  </div>
}
